import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import EventEntries from './EventEntries';
import EventSignup from './EventSignup';
import Auth from '@aws-amplify/auth';
import {CognitoUserSession} from 'amazon-cognito-identity-js';
import EditEventDetailsPage from './EditEventDetailsPage';
import EditClasses from './EditClasses';


type PathParamsType = {
    id: string,
    country: string
}

interface State {
    event : SelfTimingEvent;
    isLoading : boolean;
    view : string;
    entrylist : EventEntryList;
}


class EventPage extends React.Component<RouteComponentProps<PathParamsType> & WithTranslation, State>
{
    componentWillMount() {       
        this.updateEvent();
    }

    updateEvent = () => {
        var backend = new SelfTimingBackend();
        this.setState({isLoading:true});
        let eventId = this.props.match.params.id;
        backend.getEvent(eventId).then((event) => {
            this.setState({event : event, isLoading : false});
        });
    }
    fetchEntries = () => {
        let eventId = this.props.match.params.id;
        var backend = new SelfTimingBackend();
        this.setState({isLoading:true});
        console.log('getting entries: ' + eventId);
        backend.getEntriesForEvent(eventId).then((entrylist) => {
            console.log(entrylist);
            this.setState({entrylist : entrylist, isLoading : false,view:'entries'});
        })
    }
    render()
    {
        const { classes,t } = this.props as any;
        return <Card style={{margin: '2px'}}>
        <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={(this.state && this.state.event && this.state.event.Name) ? this.state.event.Name : ''}/>       
        {this.state && this.state.isLoading &&
           <LinearProgress  />
        }
        <div style={{padding:'5px'}}>
            {this.state && this.state.event &&
                this.renderView()
            }
        </div>
        </Card>
    }

   
    renderView() {
        if (this.state.view == "entries")
        {
         return   <EventEntries EntryList={this.state.entrylist} back={this.setView('')} enter={this.setView('signup')} />
        }
        else if (this.state.view == "signup")
        {
            return <EventSignup {...this.state.event} back={this.setView('')}/>
        }
        else if (this.state.view == "editdetails")
        {
            return <EditEventDetailsPage Event={this.state.event} 
            back={this.setView('')}
            />
        }
        else if (this.state.view == "editclasses")
        {
            return <EditClasses Event={this.state.event} 
            back={this.setView('')}
            />
        }
        else if (this.state.view == "results")
        {

        }
        else 
        {
            
            return this.renderEventData();
        }
    }

    setView = (view : string) => () => {
        if (view == "entries")
        {
            this.fetchEntries();
        }
        else if (view=="signup")
        {
            this.setState({view:'signup'});
        }
        else if (view=="editdetails")
        {
            this.setState({view:'editdetails'});
        }
        else if (view=="editclasses")
        {
            this.setState({view:'editclasses'});
        }
        else 
        {
            this.updateEvent();
            this.setState({view:""});
        }
    }

    renderEventData()
    {
        const { classes,t } = this.props as any;
        return <div>
             {this.state && this.state.event && this.state.event.IsAdmin &&
                <Card className={classes.cardHeader} style={{margin:'5px',padding:'5px', color:'#FFF'}}>
                    <h3 style={{margin:0}}>Administratör</h3>
                    <Button onClick={this.setView('editdetails')} variant="contained" color="secondary" style={{margin:'3px'}}>Tävlingsuppgifter</Button> 
                    <Button onClick={this.setView('editclasses')} variant="contained" color="secondary" style={{margin:'3px'}}>Klasser</Button> 
                    <Button variant="contained" color="secondary" style={{margin:'3px'}} disabled>Hantera Resultat</Button> 
                    <Button variant="contained" color="secondary" style={{margin:'3px'}}>Ta bort tävling</Button> 
                </Card>
            }
            <Card style={{padding:'5px'}}>
                <b>{t('COURSE_DATE')}</b>: {moment(this.state.event.Date).format("YYYY-MM-DD")}<br/>
                <b>{t('COURSE_NAME')}</b>: {this.state.event.Name}<br/>
                <b>{t('COURSE_ORGANIZER')}</b>: {this.state.event.Organizer}<br/>
                <b>{t('COURSE_DESCRIPTION')}</b>: {this.state.event.Description}<br/>
                <b>{t('COURSE_ENTRYOPEN')}</b>: {this.state.event.EntryOpen ? t('COURSE_YES') : t('COURSE_NO')}<br/>
                {this.state && this.state.event && this.state.event.IsAdmin &&
                    <span><b>{t('COURSE_SHOWPUBLIC')}</b>: {this.state.event.ShowPublic ? t('COURSE_YES') : t('COURSE_NO')}</span>
                }
            
                <Card style={{margin:'5px',padding:'5px', background:'#EEE'}}>
                <Button variant="contained" color="primary" onClick={this.setView('signup')} disabled={!this.state.event.Classes || this.state.event.Classes.length==0}>Anmäl dig</Button> <Button onClick={this.setView('entries')} variant="contained" color="primary" disabled={!this.state.event.Classes || this.state.event.Classes.length==0}>Visa alla anmälda</Button> <Button variant="contained" color="primary" disabled={!this.state.event.Classes || this.state.event.Classes.length==0}>Visa resultat</Button>
                </Card>
                <p>
                    <h3>{t('COURSE_CLASSES')}</h3>
                    {this.state.event.Classes && this.state.event.Classes.map((cl,idx) => {
                        return <div><b>{cl.Name}</b>, {(Math.round(cl.CourseLength/100)/10)+"km"}</div>
                    })}
                </p>
            </Card>
        </div>        
    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: palette.primary.main,
      },
        cardHeaderTitle: {
            fontSize: '12px',
            lineHeight: '12px'
        }
  
});
export default withStyles(useStyles)(withRouter(withTranslation()(EventPage) as any));